import { observable, action } from 'mobx';
import gql from 'graphql-tag';

const CeilingMutation = gql`
    mutation CeilingMutation(
        $URLID: String!
        $RoomNum: Int!
        $RoomSection: String!
        $RoomData: String!
    ) {
        toolSubmissionMutation(
            URLID: $URLID
            RoomNum: $RoomNum
            RoomSection: $RoomSection
            RoomData: $RoomData
        ) {
            URLID
            Error
        }
    }
`;

export class CeilingStore {
    appStore;

    currentRoomNum;

    @observable goNext = false;

    @observable loading = false;

    @action reset() {
        this.goNext = false;
    }

    constructor(opts) {
        this.appStore = opts.appStore;
        this.currentRoomNum = opts.currentRoomNum;
    }

    getMutation(values) {
        return {
            mutation: CeilingMutation,
            variables: {
                URLID: this.appStore.submissionID,
                RoomNum: this.currentRoomNum,
                RoomSection: 'ceiling',
                RoomData: JSON.stringify(values)
            },
            fetchPolicy: 'no-cache',
            context: {
                headers: {
                    'X-CSRF-TOKEN': this.appStore.sectoken
                }
            }
        };
    }

    async save(values, form, goNext) {
        this.loading = true;
        this.appStore.updateUserData(
            values,
            'ceiling',
            this.currentRoomNum
        );
        this.appStore.save(this.getMutation(values), this, form, goNext);
    }
}
